import { Card, Table } from "antd";
import { ReportDomainGap } from "../../repository/data.default";
import BandTag from "../../controls/BandTag";

export interface DomainGapTableProps {
  readonly domainGaps: ReportDomainGap[];
}

// Level-1 (Gap composites): paired Manager-vs-Employee domain gaps.
function DomainGapTable(props: DomainGapTableProps) {
  return (
    <Card size="small" title="Domain gaps (Manager vs Employee)">
      <Table
        size="small"
        rowKey="domain"
        pagination={false}
        dataSource={props.domainGaps}
        locale={{ emptyText: "No paired domains with data" }}
        columns={[
          { title: "Domain", dataIndex: "domain", key: "domain" },
          {
            title: "Manager %",
            dataIndex: "minuendValue",
            key: "minuendValue",
            width: 110,
            render: (v: number | null) => (v != null ? v.toFixed(1) : "—"),
          },
          {
            title: "Employee %",
            dataIndex: "subtrahendValue",
            key: "subtrahendValue",
            width: 110,
            render: (v: number | null) => (v != null ? v.toFixed(1) : "—"),
          },
          {
            title: "Gap %",
            dataIndex: "gap",
            key: "gap",
            width: 90,
            render: (v: number | null) => (v != null ? v.toFixed(1) : "—"),
          },
          {
            title: "Band",
            dataIndex: "bandLabel",
            key: "bandLabel",
            width: 220,
            render: (label: string | null, r: ReportDomainGap) => (
              <BandTag label={label} color={r.bandColor} />
            ),
          },
          {
            title: "Recommended action",
            dataIndex: "recommendation",
            key: "recommendation",
            render: (v: string | null) => v ?? "—",
          },
        ]}
      />
    </Card>
  );
}

export default DomainGapTable;
